import React,{useState,useEffect,useCallback} from 'react';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/common/imageWithBasePath';
import { useNotificationContext } from '../../context/NotificationContext';
import { AnimatePresence, motion } from 'framer-motion';
import { useFilterData } from "../../context/FilterContext";
import api from "../../api";
import moment from "moment";
import LeaveModal from '../leave/LeaveModal';
import { all_routes } from '../router/all_routes';
import { useNavigate } from "react-router-dom";

const Notifications: React.FC = () => {
    const { notifications, markAllAsRead, fetchTodaysUnreadNotifications,loading, markAsRead } = useNotificationContext();
    const { filtersData } = useFilterData();
    const routes = all_routes;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const unreadCount = notifications.filter(n => !n.isRead).length;
    const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);
    const [employeesForm, setEmployeesForm] = useState<Employee[]>([]);
    const [validationErrors, setValidationErrors] = useState<ValidationErrors>(
        {}
      );
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const initialRole = storedUser?.role_name ?? null;
    const [userRole, setUserRole] = useState<number | null>(initialRole);
    const navigate = useNavigate();

      type ValidationErrors = {
    selectedType?: string;
    noOfLeave?: string;
    notes?: string;
  };
  
    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
        const loggedInUserId = String(storedUser?.id);
        setLoggedInUserId(loggedInUserId);
      }, []); // run once on mount


      useEffect(() => {
          if (filtersData && Object.keys(filtersData).length > 0) {
              setEmployeesForm(filtersData?.names);
          }
      }, [filtersData]);

  interface Employee {
    id: number;
    name: string;
    [key: string]: any;
  }

  interface LeaveDetails {
    showModal1: boolean;
    isEditMode: boolean;
    editId?: number;
    leaveType: number | undefined;
    leaveDuration: string;
    singleDate: string;
    startDate: string;
    endDate: string;
    halfShortDate: string;
    halfDayType: string;
    reason: string;
    status: string;
    disableAllFields: boolean;
    disableAllExceptStatus: boolean;
    userId?: number;
    leaveAppliedDate: string;
    users: Employee[];
    selectedEmployeeId: number | undefined;
    validationErrors?: any;
    currentPage?: number;
    pageSize?: number;
  }

  const [leaveDetails, setLeaveDetails] = useState<LeaveDetails>({
      showModal1: false,
      isEditMode: false,
      leaveType: undefined,
      leaveDuration: "",
      singleDate: "",
      startDate: "",
      endDate: "",
      halfShortDate: "",
      halfDayType: "",
      reason: "",
      status: "",
      disableAllFields: false,
      disableAllExceptStatus: false,
      leaveAppliedDate: "",
      selectedEmployeeId: parseInt(loggedInUserId || "0"),
      users: employeesForm,
    });

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        console.log("closemodal called:", isModalOpen);
        setLeaveDetails({} as LeaveDetails);
      }, []);

  interface LeaveEditResponse {
    duration: string;
    half: number;
    from_date: string;
    to_date?: string;
    reason?: string;
    leave_type?: number;
    status: number;
    user_id: number;
    created_at: string;
  }

  const isDateInPast = (date: string) => {
      return moment(date).isBefore(moment(), "day");
    };
  
  const formatDate = (date: string) =>
      date ? moment(date, "YYYY-MM-DD").format("DD-MMM-YYYY") : "";
  const formatLeaveAppliedDate = (date: string) =>
      date ? moment(date).format("DD-MMM-YYYY hh:mm A") : "";

  const isDateToday = (dateStr: string) => {
    const inputDate = new Date(dateStr);
    const today = new Date();
    return (
      inputDate.getFullYear() === today.getFullYear() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getDate() === today.getDate()
    );
  };
  //   setIsModalOpen(true);

  //   try {
  //     const response = await api<LeaveEditResponse>(
  //       `/edit-leave-request/${id}`,
  //       {
  //         method: "GET",
  //       }
  //     );

  //     const data = response;

  //     let leaveDuration = "";
  //     if (data.duration === "1") leaveDuration = "single";
  //     else if (data.duration === "0.5") leaveDuration = "half";
  //     else if (data.duration === "0.25") leaveDuration = "short";
  //     else if (parseInt(data.duration) > 1) leaveDuration = "multi";

  //     let half = "";
  //     if (data.half === 1) half = "first-half";
  //     else if (data.half === 2) half = "second-half";

  //     const isSingleDatePast = isDateInPast(data.from_date);
  //     const isEndDatePast = data.to_date ? isDateInPast(data.to_date) : false;
  //     const isToday = isDateToday(data.from_date);
  //     const isToDateToday = data.to_date ? isDateToday(data.to_date) : false;

  //     const disableAllExceptStatus = userRole === 2 && data.status === 2;

  //     const localDisableAllFields =
  //       disableAllExceptStatus
  //         ? true
  //         : [3, 5].includes(data.status) ||
  //           (data.status === 4 &&
  //             isSingleDatePast &&
  //             (!data.to_date || isEndDatePast) &&
  //             (userRole === 1 || userRole === undefined)) ||
  //           ((data.status === 4 || data.status === 2) &&
  //             userRole === 2 &&
  //             (!data.to_date || isEndDatePast));


  //     console.log("selectedUserId leave:", data.user_id);

  //     setLeaveDetails({
  //       showModal1: true,
  //       isEditMode: true,
  //       editId: id,
  //       leaveType: data.leave_type || undefined,
  //       leaveDuration,
  //       singleDate: formatDate(data.from_date),
  //       startDate: formatDate(data.from_date),
  //       endDate: formatDate(data.to_date ?? ""),
  //       halfShortDate: formatDate(data.from_date),
  //       halfDayType: half,
  //       reason: data.reason || "",
  //       status: String(data.status) || "",
  //       disableAllFields: localDisableAllFields,
  //       disableAllExceptStatus,
  //       userId: data.user_id || 0,
  //       leaveAppliedDate: formatLeaveAppliedDate(data.created_at),
  //       users: employeesForm,
  //       selectedEmployeeId: selectedUserId,
  //       validationErrors,
  //       currentPage:1,
  //       pageSize:10,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching leave request:", error);
  //   }
  // };

  const handleEdit = async (id: number) => {
      setIsModalOpen(true)
    
      try {
        const response = await api<LeaveEditResponse>(`/edit-leave-request/${id}`, {
          method: "GET",
        });
        
        const data = response; 
        console.log("leave",data)   
    
        let leaveDuration = "";
        if (data.duration === "1") leaveDuration = "single";
        else if (data.duration === "0.5") leaveDuration = "half";
        else if (data.duration === "0.25") leaveDuration = "short";
        else if (parseInt(data.duration) > 1) leaveDuration = "multi";
    
        let half = "";
        if (data.half === 1) half = "first-half";
        else if (data.half === 2) half = "second-half";
    
        const isSingleDatePast = isDateInPast(data.from_date);
        const isEndDatePast = data.to_date ? isDateInPast(data.to_date) : false;
    
        const disableAllExceptStatus = userRole === 2 && data.status === 2;
  
        const localDisableAllFields =
          disableAllExceptStatus
            ? true
            : [3, 5].includes(data.status) ||
              (data.status === 4 &&
                isSingleDatePast &&
                (!data.to_date || isEndDatePast) &&
                (userRole === 1 || userRole === undefined)) ||
              ((data.status === 4 || data.status === 2) &&
                userRole === 2 &&
                (!data.to_date || isEndDatePast));
    
          console.log("selectedUserId leave:", data.user_id );
    
        setLeaveDetails({
          showModal1: true,
          isEditMode: true,
          editId: id,
          leaveType: data.leave_type || undefined,
          leaveDuration,
          singleDate: formatDate(data.from_date),
          startDate: formatDate(data.from_date),
          endDate: formatDate(data.to_date ?? ""),
          halfShortDate: formatDate(data.from_date),
          halfDayType: half,
          reason: data.reason || "",
          status: String(data.status) || "",
          disableAllFields: localDisableAllFields,
          disableAllExceptStatus,
          userId: data.user_id || 0,
          leaveAppliedDate: formatLeaveAppliedDate(data.created_at),
          users:employeesForm,
          selectedEmployeeId:data.user_id ?? 0,
          validationErrors,
        });
      } catch (error) {
        console.error("Error fetching leave request:", error);
      }
    };

function formatDateTime(dateString: string): string {
  console.log("dateString", dateString);
  if (!dateString) return "Invalid date";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid date";

  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };

  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(date);
  const get = (type: string) =>
    parts.find((p) => p.type === type)?.value || '';

  const day = get('day');
  const month = get('month').toUpperCase();
  const year = get('year');
  const hour = get('hour');
  const minute = get('minute');
  const second = get('second');
  const dayPeriod = get('dayPeriod');

  // Final check to ensure no blank values
  if ([day, month, year, hour, minute, second, dayPeriod].some(v => !v)) {
    return "Invalid date";
  }

  return `${day}-${month}-${year}, ${hour}:${minute}:${second} ${dayPeriod}`;
}

  return (
    <>
      <div className="dropdown-menu dropdown-menu-end notification-dropdown p-3">
        <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 notifs-mb">
          <h4 className="notification-title">
            Notifications ({unreadCount})
          </h4>

          {unreadCount > 0 && (
            <div className="d-flex align-items-center">
              <button
                  onClick={(e) => {
                    e.stopPropagation();
                    markAllAsRead();
                  }}
                  className="mark-btn btn p-0 lh-1 fw-normal border-0 bg-transparent shadow-none text-primary text-decoration-none"
                >
                  Mark all as read
                </button>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    fetchTodaysUnreadNotifications();
                  }}
                  className="today-btn-notif btn p-0 lh-1 border-0 fw-normal bg-transparent shadow-none text-dark text-decoration-none hover-text-today"
                >
                  <i className="ti ti-calendar-due me-1"></i>Today
                </button>
                {/* <ul className="dropdown-menu mt-2 p-3">
                  <li><button className="dropdown-item rounded-1">This Week</button></li>
                  <li><button className="dropdown-item rounded-1">Last Week</button></li>
                  <li><button className="dropdown-item rounded-1">Last Month</button></li>
                </ul> */}
              {/* </div> */}
            </div>
          )}
        </div>

        <div className="noti-content">
          <div className="d-flex flex-column margin-top-noti">
            {loading ? (
              <>
                {[1, 2, 3].map((n) => (
                  <div className="shimmer-item mb-3 pb-3" key={n}>
                    <div className="shimmer-avatar" />
                    <div className="shimmer-lines w-100">
                      <div className="shimmer-line w-75 mb-1" />
                      <div className="shimmer-line w-50" />
                    </div>
                  </div>
                ))}
              </>
            ) : notifications.length === 0 ? (
              <div className="text-muted text-center main-notifs-mobile">No unread notifications.</div>
            ) : (
              <AnimatePresence mode="popLayout">
                {notifications.map((n) => (
                  <motion.div
                    key={n.id}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.3 }}
                    className="border-bottom main-notifs-mobile"
                    onClick={(e) => {
                      e.stopPropagation(); 
                      markAsRead(n.id);
                      if (n.type === "interview") {
                        navigate(`/interviews?interviewId=${n.interviewId}`);     
                      } else {
                        handleEdit(n.leaveId);
                      }
                    }}
                  >
                    <Link to="#" onClick={(e) => e.preventDefault()}>
                      <div className="d-flex align-items-center justify-content-between">
                        {/* <span className="avatar avatar-lg me-2 flex-shrink-0">
                          <ImageWithBasePath src="/assets/img/profiles/avatar-01.jpg" alt="Profile" />
                        </span> */}
                        <div className="flex-grow-1 notifs-mobile">
                          <p className="mb-1">
                            <span className="text-dark fw-semibold">{n.message}</span>
                          </p>
                          <span>{formatDateTime(n.createdAt)}</span>
                        </div>
                        {(n.type === "interview" && n.meetingLink) && (
                          <a
                            href={n.meetingLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary ms-2"
                            onClick={(e) => e.stopPropagation()} // prevent parent Link click
                          >
                            Join Meeting
                          </a>
                        )}
                      </div>
                    </Link>
                  </motion.div> 
                ))}
              </AnimatePresence>
            )}
          </div>
        </div>

        <div className="d-flex p-0 margin-close-view">
          <Link to="#" className="btn btn-light w-100 me-2">Close</Link>
          <Link to={routes.AllNotifications} className="btn btn-primary w-100 view-all">View All</Link>
        </div>
      </div>

      <LeaveModal
        leaveDetails={leaveDetails}
        isOpen={isModalOpen}
        onClose={closeModal}
        userRole={userRole ?? 0}
      >
        <></>
      </LeaveModal>   
    </>
  );
};

export default Notifications;